module.exports = __webpack_public_path__ + "img/custom.f04c9302.png";